export default "__VITE_ASSET__0f4f57ae__"